/**
 * Escrituras de la lección priest-2 (pastoral / bautismo). DyC 20 y 107 alineados con scriptures.training.core3; DyC 18 según churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const priest2TrainingScripturesEs: Scripture[] = [
  {
    id: 'dc-20-41-43',
    reference: 'Doctrina y Convenios 20:41–43',
    text:
      'y confirmar por la imposición de manos a los que se bautizan en la iglesia, para que reciban el bautismo de fuego y del Espíritu Santo, de acuerdo con las Escrituras; y enseñar, exponer, exhortar, bautizar y velar por la iglesia; y confirmar a los miembros de la iglesia por la imposición de manos y el otorgamiento del Espíritu Santo;',
    verses: [
      {
        verse: 41,
        text: 'y confirmar por la imposición de manos a los que se bautizan en la iglesia, para que reciban el bautismo de fuego y del Espíritu Santo, de acuerdo con las Escrituras;',
      },
      {
        verse: 42,
        text: 'y enseñar, exponer, exhortar, bautizar y velar por la iglesia;',
      },
      {
        verse: 43,
        text: 'y confirmar a los miembros de la iglesia por la imposición de manos y el otorgamiento del Espíritu Santo;',
      },
    ],
    context: 'Deberes de los élderes: confirmación, enseñanza, bautismo y velar por la iglesia.',
  },
  {
    id: 'dc-18-10-16',
    reference: 'Doctrina y Convenios 18:10–16',
    text:
      'Recordad que el valor de las almas es grande a la vista de Dios; porque he aquí, el Señor vuestro Redentor padeció la muerte en la carne; por tanto, sufrió el dolor de todos los hombres, a fin de que todo hombre pudiese arrepentirse y venir a él. Y ha resucitado de entre los muertos, para traer a todos los hombres a él, mediante las condiciones del arrepentimiento. ¡Y cuán grande es su gozo por el alma que se arrepiente! Así que, sois llamados a proclamar el arrepentimiento a este pueblo. Y si acontece que trabajáis todos vuestros días proclamando el arrepentimiento a este pueblo y me traéis aun cuando fuere una sola alma, ¡cuán grande será vuestro gozo con ella en el reino de mi Padre! Y ahora, si vuestro gozo será grande con un alma que me hayáis traído al reino de mi Padre, ¡cuán grande no será vuestro gozo si me trajereis muchas almas!',
    verses: [
      {
        verse: 10,
        text: 'Recordad que el valor de las almas es grande a la vista de Dios;',
      },
      {
        verse: 11,
        text: 'porque he aquí, el Señor vuestro Redentor padeció la muerte en la carne; por tanto, sufrió el dolor de todos los hombres, a fin de que todo hombre pudiese arrepentirse y venir a él.',
      },
      {
        verse: 12,
        text: 'Y ha resucitado de entre los muertos, para traer a todos los hombres a él, mediante las condiciones del arrepentimiento.',
      },
      {
        verse: 13,
        text: '¡Y cuán grande es su gozo por el alma que se arrepiente!',
      },
      {
        verse: 14,
        text: 'Así que, sois llamados a proclamar el arrepentimiento a este pueblo.',
      },
      {
        verse: 15,
        text: 'Y si acontece que trabajáis todos vuestros días proclamando el arrepentimiento a este pueblo y me traéis aun cuando fuere una sola alma, ¡cuán grande será vuestro gozo con ella en el reino de mi Padre!',
      },
      {
        verse: 16,
        text: 'Y ahora, si vuestro gozo será grande con un alma que me hayáis traído al reino de mi Padre, ¡cuán grande no será vuestro gozo si me trajereis muchas almas!',
      },
    ],
    context: 'El valor de las almas, el arrepentimiento y el gozo de llevar almas a Cristo.',
  },
  {
    id: 'dc-107-13-14',
    reference: 'Doctrina y Convenios 107:13–14',
    text:
      'El segundo sacerdocio es llamado el Sacerdocio de Aarón, porque se confirió a Aarón y a su descendencia por todas sus generaciones. Se llama el sacerdocio menor porque es una dependencia del mayor, o sea, el Sacerdocio de Melquisedec, y tiene el poder para administrar las ordenanzas exteriores.',
    verses: [
      {
        verse: 13,
        text: 'El segundo sacerdocio es llamado el Sacerdocio de Aarón, porque se confirió a Aarón y a su descendencia por todas sus generaciones.',
      },
      {
        verse: 14,
        text: 'Se llama el sacerdocio menor porque es una dependencia del mayor, o sea, el Sacerdocio de Melquisedec, y tiene el poder para administrar las ordenanzas exteriores.',
      },
    ],
    context: 'El Sacerdocio de Aarón y su relación con el de Melquisedec.',
  },
];
